export enum IndividualListSex {
  female = '0',
  male = '1',
  unknown = '2'
}
